import api from "./api";
import { errorHandling } from "./error.handling";
import { storage } from "./storage.service";
import { storageKeys } from "../Constants/storage.key";

//const basePath = `${process.env.REACT_APP_API_AUTH_BASE_URL}/v3/Auth`;
const basePath = 'https://nc8.olharfixo.com.br/Auth/api/v3/Auth'

export const authService = {
  auth,
  authenticated,
  recoverPass,
  logoff,
  key,
  resetPass,
  authorizedLogin
};

async function auth(payload) {
  try {
    const response = await api.post(`${basePath}/login`, payload);

    const treated = errorHandling.handleResponse(response, "authService.auth");
    if (treated) {
      if (treated.token) {
        storage.save(storageKeys.access_and_token, treated);
        return true;
      }
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "authService.auth");
    return false;
  }
}

async function authorizedLogin(payload) {
  try {
    const response = await api.post(`${basePath}/users/authorized/login`, payload);

    const treated = errorHandling.handleResponse(response, "authService.authorizedLogin");
    if (treated) {
      return treated
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "authService.authorizedLogin");
    return null;
  }
}

async function key(payload) {
  try {
    const response = await api.post(`${basePath}/login/key`, payload);

    const treated = errorHandling.handleResponse(response, "authService.key");
    if (treated){
      return treated;
    }
    
  } catch (error) {
    errorHandling.cathError(error, "authService.auth");
    return false;
  }
}

function authenticated() {
  try {
    const accessToken = storage.get(storageKeys.access_and_token);
    if (accessToken.token) return true;
  } catch {
    return false;
  }

  return false;
}

function logoff() {
  console.clear();
  localStorage.clear();
  sessionStorage.clear();
}

async function recoverPass(payload) {
  try {
    const response = await api.post(`${basePath}/password/forgot`, payload);

    const treated = errorHandling.handleResponse(
      response,
      "authService.recoverPass"
    );
    if (treated) {
      if (treated.message) return treated.message;
      return treated
    }
  } catch {
    return null;
  }

  return null;
}

async function resetPass(payload) {
  try {
    const response = await api.post(`${basePath}/password/reset`, payload);

    const treated = errorHandling.handleResponse(
      response,
      "authService.resetPass"
    );
    if (treated) {
      if (treated.message) return treated.message;
      return treated
    }
  } catch {
    return null;
  }

  return null;
}

